import * as bootstrap from "bootstrap";

const MISSING_FIELDS_TAB_LINK_SELECTOR = "[data-sheet-info-tab-link][data-tab-target]";

export function initSheetInfoMissingFields(root = document) {
  if (!(root instanceof Document || root instanceof Element)) {
    return;
  }

  const links =
    root instanceof Element && root.matches(MISSING_FIELDS_TAB_LINK_SELECTOR)
      ? [root]
      : Array.from(root.querySelectorAll(MISSING_FIELDS_TAB_LINK_SELECTOR));

  links.forEach((link) => {
    if (!(link instanceof HTMLAnchorElement) || link.dataset.sheetInfoTabLinkInitialized === "1") {
      return;
    }

    link.dataset.sheetInfoTabLinkInitialized = "1";
    link.addEventListener("click", (event) => {
      const target = String(link.dataset.tabTarget ?? "");
      const tabTrigger = target ? document.querySelector(`[data-bs-target="${target}"]`) : null;

      if (!(tabTrigger instanceof HTMLElement)) {
        return;
      }

      event.preventDefault();
      bootstrap.Tab.getOrCreateInstance(tabTrigger).show();
      tabTrigger.focus();
    });
  });
}
